import React from 'react'
import Head from 'next/head'

import { app } from '../../configuration'

export type MetasProps = {
  applicationName?: string
  title?: string
  description?: string
  image?: string
  twitter_card?: string
  url?: string
  type?: string
  twitter_account?: string
  locale?: string
  robots?: string
  noindex?: boolean
}

const Metas: React.FC<MetasProps> = ({
  title,
  description,
  type = 'website',
  image,
  twitter_card,
  url,
  twitter_account,
  robots,
  locale,
  noindex,
}) => {
  return (
    <Head>
      <meta charSet="utf-8" />
      {title && <title>{title}</title>}
      {robots && <meta property="robots" content={robots} />}
      {url && <link rel="canonical" href={url} />}
      {noindex || app.NO_INDEX ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <>
          <meta name="robots" content="index, follow" />
          <meta
            name="googlebot"
            content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
          />
        </>
      )}
      <meta name="screen-orientation" content="portrait" />
      <meta
        content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5"
        name="viewport"
      />

      <link
        rel="preconnect"
        href="https://sessions.bugsnag.com"
        crossOrigin="anonymous"
      />

      {title && <meta property="og:title" content={title} />}
      {description && <meta name="description" content={description} />}

      {/* // socials */}

      {description && <meta property="og:description" content={description} />}
      {type && <meta property="og:type" content={type} />}
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      {locale && <meta property="og:locale" content={locale} />}

      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {twitter_card && <meta name="twitter:card" content={twitter_card} />}
      {image && <meta name="twitter:image" content={image} />}
      {twitter_account && (
        <>
          <meta property="twitter:site" content={twitter_account} />
          <meta name="twitter:creator" content={twitter_account} />
        </>
      )}

      {/* // favicon */}

      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#00a7e7" />
      <meta name="msapplication-TileColor" content="#00A7E7" />
      <meta name="theme-color" content="#ffffff" />

      <meta name="full-screen" content="yes" />
      <meta name="browsermode" content="application" />

      <meta name="nightmode" content="enable" />

      <meta name="layoutmode" content="fitscreen" />

      <meta name="imagemode" content="force" />
    </Head>
  )
}

export default Metas
